@if (link(); as link) {
  <p class="contractor-hint" data-cy="repair-task-contractor-hint">
    Dienstleister fehlt? Zuerst
    <a [routerLink]="link.commands" [queryParams]="link.queryParams" target="_blank">{{ link.label }}</a>.
  </p>
}
